import { render, staticRenderFns } from "./merchantJoin.vue?vue&type=template&id=2beb6b74&scoped=true"
import script from "./merchantJoin.vue?vue&type=script&lang=js"
export * from "./merchantJoin.vue?vue&type=script&lang=js"
import style0 from "./merchantJoin.vue?vue&type=style&index=0&id=2beb6b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb6b74",
  null
  
)

export default component.exports